import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "isOpen", "children", "variantProps", "dataTestId", "updatedWidth", "overlayStyles", "contentContainerStyles", "headerStyles", "initialFocusRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { useScreenSize } from '@whitbread-eos/utils';
import { Dismiss } from '../../../../assets/icons';
import Icon from '../../../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DefaultModal(_ref) {
  var _variantProps$overflo;
  var onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    children = _ref.children,
    variantProps = _ref.variantProps,
    dataTestId = _ref.dataTestId,
    updatedWidth = _ref.updatedWidth,
    overlayStyles = _ref.overlayStyles,
    contentContainerStyles = _ref.contentContainerStyles,
    externalHeaderStyles = _ref.headerStyles,
    initialFocusRef = _ref.initialFocusRef,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var prefix = dataTestId ? "".concat(dataTestId, "-") : '';
  var shouldAppearInFront = (_variantProps$overflo = variantProps === null || variantProps === void 0 ? void 0 : variantProps.overflowVisible) !== null && _variantProps$overflo !== void 0 ? _variantProps$overflo : false;
  var isModalCentered = !!(variantProps !== null && variantProps !== void 0 && variantProps.isCentered);
  var width = _objectSpread({
    mobile: 'full',
    sm: 'auto'
  }, updatedWidth);
  var _useScreenSize = useScreenSize(),
    isLessThanMd = _useScreenSize.isLessThanMd;
  return _jsxs(Modal, _objectSpread(_objectSpread({
    "data-testid": "".concat(prefix, "ChakraModal"),
    preserveScrollBarGap: true,
    isCentered: isModalCentered,
    scrollBehavior: "inside",
    isOpen: isOpen,
    onClose: onClose,
    initialFocusRef: initialFocusRef,
    trapFocus: true,
    blockScrollOnMount: true,
    returnFocusOnClose: true
  }, otherProps), {}, {
    size: isLessThanMd && variantProps !== null && variantProps !== void 0 && variantProps.sizeSm ? 'full' : 'md',
    children: [_jsx(ModalOverlay, _objectSpread({}, overlayStyles)), _jsxs(ModalContent, _objectSpread(_objectSpread({
      containerProps: contentContainerStyles,
      "data-testid": "".concat(prefix, "ModalContent")
    }, modalContentStyle(shouldAppearInFront, isModalCentered, variantProps === null || variantProps === void 0 ? void 0 : variantProps.sizeSm, isLessThanMd)), {}, {
      width: otherProps.size ? 'auto' : width,
      children: [_jsxs(ModalHeader, _objectSpread(_objectSpread(_objectSpread({}, modalHeaderStyle), externalHeaderStyles), {}, {
        "data-testid": "".concat(prefix, "ModalHeader"),
        children: [variantProps && _jsx(Flex, _objectSpread(_objectSpread(_objectSpread({}, headerTitleStyle), variantProps === null || variantProps === void 0 ? void 0 : variantProps.externalTitleStyling), {}, {
          "data-testid": "".concat(prefix, "ModalTitle"),
          children: variantProps.title
        })), _jsx(ModalCloseButton, _objectSpread(_objectSpread({
          "data-testid": "".concat(prefix, "ModalCloseButton")
        }, modalCloseButtonStyle), {}, {
          children: _jsx(Icon, {
            svg: _jsx(Dismiss, {
              transform: "scale(1.1)"
            })
          })
        }))]
      })), _jsx(Box, _objectSpread({}, delimiterModalStyle)), _jsx(ModalBody, _objectSpread(_objectSpread({
        "data-testid": "".concat(prefix, "ModalBody")
      }, modalBodyStyle), {}, {
        children: _jsx(Box, {
          overflow: "auto",
          maxH: "calc(100vh - 4rem)",
          children: children
        })
      }))]
    }))]
  }));
}
var modalBodyStyle = {
  overflow: 'auto',
  p: 0
};
var modalContentStyle = (overflowVisible, isModalCentered, sizeSm, isLessThanMd) => {
  return {
    maxW: 'auto',
    maxH: 'auto',
    overflow: overflowVisible ? 'visible' : 'auto',
    height: {
      mobile: 'full',
      sm: 'fit-content'
    },
    my: 0,
    borderRadius: {
      mobile: '0',
      sm: isLessThanMd && sizeSm ? 0 : '0.875rem'
    },
    boxShadow: '0 0.125rem 0.75rem var(--chakra-colors-darkGrey2)',
    p: 0,
    top: isModalCentered ? 0 : {
      mobile: 0,
      sm: sizeSm ? 0 : '2.938rem',
      md: '3.75rem',
      xl: '6.375rem'
    }
  };
};
var modalHeaderStyle = {
  minH: 'var(--chakra-space-xxl)',
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  alignItems: 'center',
  py: 'sm',
  px: {
    mobile: 'md',
    sm: 'lg'
  }
};
var delimiterModalStyle = {
  mx: {
    mobile: 'md',
    sm: 'lg'
  },
  h: '0.063rem',
  bgColor: 'lightGrey4'
};
var headerTitleStyle = {
  ml: 'xl',
  color: 'darkGrey1',
  justify: 'center',
  justifyContent: 'center',
  fontSize: 'lg',
  lineHeight: '3',
  fontFamily: 'header',
  padding: 0
};
var modalCloseButtonStyle = {
  h: 'var(--chakra-space-xl)',
  w: 'var(--chakra-space-xl)',
  position: 'static',
  alignSelf: 'flex-end',
  fontSize: 'xs',
  lineHeight: '3',
  fontWeight: '400',
  color: 'darkGrey2',
  _focus: {
    boxShadow: 'none'
  },
  _hover: {
    bgColor: 'transparent'
  },
  _active: {
    bgColor: 'transparent'
  }
};